import styled from 'styled-components';
import { Caption, Subtitle2, colors, fontWeights, spacing, body2 } from 'ui/theme';
import { Spinner } from 'ui/spinner';
import { Body2NoMargin } from 'modules/frequencyManagement/components/Content.styles';
import { Wrapper } from 'modules/frequencyManagement/components/summaryInset/SummaryInset.styled';

export const EditingHeaderRow = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 255px;
  gap: ${spacing.quarter};
`;
export const EditingRangeText = styled(Subtitle2)`
  font-weight: ${fontWeights.bold};
  display: flex;
  gap: ${spacing.quarter};
  align-items: center;
  margin: 0;
`;

export const EditingSpacedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const FlexSummaryInset = styled(Wrapper)`
  background: ${colors.backgroundPrimary};
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  padding: 0;
`;

export const InlineFlex = styled.div`
  align-items: center;
  display: inline-flex;
  gap: ${spacing.half};
`;

export const EditingInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.threeQuarter};

  &[data-border='true'] {
    border-bottom: 1px solid ${colors.borderPrimary};
    padding-bottom: ${spacing.threeQuarter};
  }
`;

export const SecondaryCaption = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const LogoSpinner = styled(Spinner)`
  & {
    height: unset;
  }
`;
export const Review = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;
export const ReviewInputRow = styled.div`
  display: flex;
  padding-bottom: ${spacing.half};
`;
export const MarginlessBody2Bold = styled.span`
  ${body2};
  font-weight: ${fontWeights.bold};
`;
export const ReviewDataRow = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  gap: ${spacing.half};
`;
export const MarginlessBody2Secondary = styled(Body2NoMargin)`
  color: ${colors.textSecondary};
`;
export const MarginlessBody2Centered = styled(MarginlessBody2Secondary)`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: ${spacing.quarter};
`;

export const CenteredMarginlessCaption = styled(Subtitle2)`
  display: flex;
  align-self: center;
  margin: 0;
`;
